import styles from './Textarea.module.css';

export default function Textarea({ label, id, error, ...rest }) {
  return (
    <div className={styles.field}>
      {label && <label htmlFor={id} className={styles.label}>{label}</label>}
      <textarea id={id} className={`${styles.textarea} ${error ? styles.errorState : ''}`} rows={5} {...rest} />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
